/**
 * Created by Lenovo on 2017/5/17.
 */
import React, {
    Component,
    PropTypes
} from 'react';
import BoxHeader from "CONFIG/component/boxHeader"
import ContentHeader from 'CONFIG/component/contentHeaderLeft'
import {language} from 'UTIL/common'
import ellaService from 'SERVICES/purifier/ella/ellaService'
export default class UserDistributionStatistics extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    componentDidMount() {
        ellaService.userProvinceStatistics().then(body => {
            console.log(body);
            this.drawCharts(body.data)
        })
    }

    drawCharts(data) {
        var option = {
            title: {
                text: '用户分布统计',
                x: 'center'
            },
            tooltip: {
                trigger: 'item'
            },
            legend: {
                orient: 'vertical',
                x: 'left',
                data: ['用户分布统计']
            },
            dataRange: {
                min: 0,
                max: 2500,
                x: 'left',
                y: 'bottom',
                text: ['高', '低'],           // 文本，默认为数值文本
                calculable: true
            },
            toolbox: {
                show: true,
                orient: 'vertical',
                x: 'right',
                y: 'center',
                feature: {
                    mark: {show: true},
                    dataView: {show: true, readOnly: false},
                    restore: {show: true},
                    saveAsImage: {show: true}
                }
            },
            roamController: {
                show: true,
                x: 'right',
                mapTypeControl: {
                    'china': true
                }
            },
            series: [
                {
                    name: '用户分布统计',
                    type: 'map',
                    mapType: 'china',
                    roam: false,
                    itemStyle: {
                        normal: {label: {show: true}},
                        emphasis: {label: {show: true}}
                    },
                    data: data
                },
            ]
        };
        $.getJSON('../../../js/china.json',
            function (data) {
                echarts.registerMap('china', data);
                var chart = echarts.init(document.getElementById('main'));
                chart.setOption(option);
            });

    }

    render() {
        return <div>
            <ContentHeader nameLg="StatisticalManagement" nameSm="UserDistributionStatistics"/>
            <section className="content">
                <div className="box box-primary color-palette-box">
                    <BoxHeader title={'UserDistributionStatistics'}/>
                    <div className="box-body">
                        <div id="main" class="main" style={{height: '500px', width: '100%'}}></div>
                    </div>
                </div>
            </section>
        </div>
    }
}



// WEBPACK FOOTER //
// ./modules/ella/statistics/userDistributionStatistics.js